import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_chart",
  "use": "icon-project_chart-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_chart\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><g stroke-linecap=\"round\"><path d=\"M10.356 4A10.775 10.775 0 003 14.227C3 20.177 7.81 25 13.742 25c4.819 0 8.897-3.182 10.258-7.565M25 14c0-6.075-4.925-11-11-11\" /></g><path stroke-linejoin=\"round\" d=\"M14 3v11h11\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol